module.exports = __webpack_public_path__ + "img/commitFive.715faa2b.png";